import React, { useState, useEffect } from "react";
import AddShiftModal from "./AddShiftModal";
import api from "../../api/axios";
import { Plus, SquarePen, Trash2 } from "lucide-react";
import Swal from "sweetalert2";

const ShiftManagement = () => {
  const [shifts, setShifts] = useState([]);
  const [editShift, setEditShift] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchShifts = async () => {
    try {
      const res = await api.get("/hrms/shifts");
      setShifts(res.data || []);
    } catch (error) {
      console.error("Failed to fetch shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, []);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This shift will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/hrms/shifts/${id}`);
          Swal.fire("Deleted!", "Shift has been deleted.", "success");
          fetchShifts();
        } catch (err) {
          Swal.fire(
            "Error",
            err.response?.data?.message || "Delete failed",
            "error"
          );
        }
      }
    });
  };

  const handleEdit = (shift) => {
    setEditShift(shift);
    setShowModal(true);
  };

  const handleNewShift = () => {
    setEditShift(null);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditShift(null);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h5 className="fs-4 fw-semibold m-0">Manage Shifts</h5>
          <span className="text-muted fs-6">
            Define work shifts for your property.
          </span>
        </div>
        <button
          type="button"
          className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
          onClick={handleNewShift}
        >
          <Plus size={18} /> Add Shift
        </button>
      </div>

      <div className="table-responsive settings-table mt-3">
        <table className="table table-hover m-0">
          <thead>
            <tr className="align-middle border-top">
              <th>Code</th>
              <th>Shift Name</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center text-muted py-3">
                  Loading..
                </td>
              </tr>
            ) : shifts.length > 0 ? (
              shifts.map((shift) => (
                <tr key={shift.id}>
                  <td>{shift.code}</td>
                  <td>{shift.name}</td>
                  <td>{shift.start_time?.slice(0, 5)}</td>
                  <td>{shift.end_time?.slice(0, 5)}</td>
                  <td>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <SquarePen
                        size={20}
                        role="button"
                        onClick={() => handleEdit(shift)}
                      />
                      <Trash2
                        size={20}
                        role="button"
                        className="text-danger"
                        onClick={() => handleDelete(shift.id)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted py-3">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <AddShiftModal
        showModal={showModal}
        onClose={handleCloseModal}
        onShiftAdded={fetchShifts}
        editShift={editShift}
      />
    </div>
  );
};

export default ShiftManagement;
